/*
 * @Author: ethan.liu
 * @Date: 2023-07-26 09:20:11
 * @LastEditTime: 2023-08-16 15:29:00
 * @Description:
 * @LastEditors: ethan.liu
 */
import Vue from 'vue';
// import ElementUI from 'element-ui';
import {
  Tabs,
  TabPane,
  InputNumber,
  Alert,
  Slider,
  Dialog,
  Button,
  Input,
  CheckboxGroup,
  Checkbox,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  MessageBox,
  Message,
  Loading,
  Notification,
  Container,
  Form,
  FormItem,
  Radio,
  Option,
  RadioGroup,
  Select,
  Table,
  TableColumn,
  Tooltip,
  Tag,
  Image,
} from 'element-ui';
import ElementLocale from 'element-ui/lib/locale';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import './utils/recordingLauncher';
import prototype from '@/assets/js/prototype';
// import mock from '@/assets/js/mock'
import store from '@/assets/js/store';
import timeHandle from '@/assets/js/time_handle.js';
import vueEsign from 'vue-esign';
import VueI18n from 'vue-i18n';
import { createPinia, PiniaVuePlugin } from 'pinia';

// 语言库
import en from '@/languages/en';
import zh from '@/languages/zh_CN';
import zhTW from '@/languages/zh_TW';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW';
import { getSystemLanguage } from '@/utils/index.js';

Vue.config.productionTip = false;

window.log = console.log;
if (process.env.NODE_ENV === 'production') {
  //由于生产环境使用打印会影响性能，在这里做一个优化，去除生产环境的打印，以后代码里的打印用 log 而不是用 console.log
  // window.log = ()=>{};
}

//用作格式化时间已经前端获得北京时间
timeHandle();

//按需引入Element组件
// Vue.use(ElementUI)
Vue.use(Alert);
Vue.use(Slider);
Vue.use(InputNumber);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Input);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Drawer);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Container);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tooltip);
Vue.use(Tag);
Vue.use(Image);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

//在vue原型链添加方法
Vue.use(prototype);

Vue.use(vueEsign);

// mock.mock(false)   //传 true 请求模拟数据, false 请求真实数据

// 注册多语言插件
Vue.use(VueI18n);
const messages = {
  en: Object.assign(en, enLocale),
  'zh-hans': Object.assign(zh, zhLocale),
  'zh-hant': Object.assign(zhTW, zhTWLocale),
};
const i18n = new VueI18n({
  locale: getSystemLanguage(), // 当前语言环境
  fallbackLocale: 'zh-hans', // 回退语言环境
  messages,
  missing: (locale, key, vm, values) => {
    const arr = key.split('.');
    return arr[arr.length - 1];
  },
});
Vue.prototype._i18n = i18n;
// 设置ElementUI语言
ElementLocale.i18n((key, value) => i18n.t(key, value));

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  pinia,
  render: (h) => h(App),
});
